// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SrGJRDdWv8viMPFv {
	display: flex;
	flex-direction: column;
	gap: var(--lok-spacing-5);

	padding: var(--lok-spacing-7);
	border: 1px solid var(--lok-color-border-light);
    background: var(--lok-color-background-default);
	border-radius: var(--lok-radius-l);

	height: 184px;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Cards/components/CardContainer/CardContainer.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,yBAAyB;;CAEzB,6BAA6B;CAC7B,+CAA+C;IAC5C,+CAA+C;CAClD,kCAAkC;;CAElC,aAAa;AACd","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--lok-spacing-5);\n\n\tpadding: var(--lok-spacing-7);\n\tborder: 1px solid var(--lok-color-border-light);\n    background: var(--lok-color-background-default);\n\tborder-radius: var(--lok-radius-l);\n\n\theight: 184px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SrGJRDdWv8viMPFv`
};
export default ___CSS_LOADER_EXPORT___;
